import gql from 'graphql-tag';


const M_UPSERT_EMAIL_LIST_EMAIL = gql`
    mutation UpsertEmailList($email: String!, $subscribed: Boolean!) {
        insert_email_list(
            objects: { email: $email, subscribed: $subscribed },
            on_conflict: { constraint: email_list_pkey, update_columns: subscribed }
        ) {
            affected_rows
        }
    }
`;


export {
    M_UPSERT_EMAIL_LIST_EMAIL
}



